import {
  setDisplayErrorSnackBar,
  setIsLoading,
} from "../../../features/userSlice";
import { etlLogsService } from "../../../services/api/etl-logs.endpoints";
import store from "../../../store";

async function getLogs(
  oauthTokenHeader: string,
  setLogs: any,
  setTotalRecords: any,
  rpp?: number,
  rid?: any,
  status?: string[],
  method?: string[],
  from?: string,
  to?: string,
  process_id?: any
) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await etlLogsService.getETLLogs(
      oauthTokenHeader,
      rpp,
      rid,
      status,
      method,
      from,
      to,
      process_id
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get page content");
    } else {
      setLogs(response?.data?.data?.records);
      setTotalRecords(response?.data?.data?.total_records);
    }
  } catch (e: any) {
    setLogs([]);
    setTotalRecords(0);
    store.dispatch(
      setDisplayErrorSnackBar({ message: e?.parsedText?.reason, type: "error" })
    );
  } finally {
    store.dispatch(setIsLoading(false));
  }
}

// This function is used to fetch logs for export to CSV
async function getLogsForExport(
  oauthTokenHeader: string,
  setLogs: any,
  rpp?: number,
) {
  try {
   
    const response = await etlLogsService.getETLLogsForExportToCSV(
      oauthTokenHeader,
      rpp
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get page content");
    } else {
      setLogs(response?.data?.data?.records);
    }
  } catch (e: any) {
    setLogs([]);
    store.dispatch(
      setDisplayErrorSnackBar({ message: e?.parsedText?.reason, type: "error" })
    );
  }
}

async function getLogsById(
  oauthTokenHeader: string,
  runId: number,
  setSingleLog: any
) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await etlLogsService.getETLLogById(
      runId,
      oauthTokenHeader
    );
    if (!response || !response.status || response.status !== 200) {
      throw new Error("Failed to get page content");
    } else {
      setSingleLog(response?.data?.data);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({ message: e?.parsedText?.reason, type: "error" })
    );
  } finally {
    store.dispatch(setIsLoading(false));
  }
}

async function runProcess(
  oauthTokenHeader: string,
  ids: any,
  setRunStatus: any
) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await etlLogsService.runProcessLogs(
      ids,
      oauthTokenHeader
    );
    if (!response || !response?.status || response.status !== 201) {
      throw new Error("Failed to get page content");
    } else {
      setRunStatus(response?.data?.reason);
    }
  } catch (e: any) {
    setRunStatus(e?.parsedText?.reason);
    store.dispatch(
      setDisplayErrorSnackBar({ message: e?.parsedText, type: "error" })
    );
  } finally {
    store.dispatch(setIsLoading(false));
  }
}

async function getDBTables(
  oauthTokenHeader: string,
  selectedSource: any,
  selectedDestination: any,
  setTables: any
) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await etlLogsService.getDBTables(
      oauthTokenHeader,
      selectedSource,
      selectedDestination
    );
    if (!response || !response?.status || response.status !== 200) {
      throw new Error("Failed to get Tables");
    } else {
      setTables(response?.data?.data);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({ message: e?.parsedText, type: "error" })
    );
  } finally {
    store.dispatch(setIsLoading(false));
  }
}

async function postMigrate(
  oauthTokenHeader: string,
  data: any,
  setMigrateResponse: any,
  setSuccess: any
) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await etlLogsService.postMigrate(oauthTokenHeader, data);
    if (!response || !response?.status || response.status !== 200) {
      throw new Error("Failed to get page content");
    } else {
      setMigrateResponse(response?.data?.data);
      setSuccess("success");
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({ message: e?.parsedText, type: "error" })
    );
  } finally {
    store.dispatch(setIsLoading(false));
  }
}

async function getBrands(oauthTokenHeader: string, data: any, setBrands: any) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await etlLogsService.getBrands(oauthTokenHeader, data);
    if (!response || !response?.status || response.status !== 200) {
      throw new Error("Failed to get page content");
    } else {
      setBrands(response?.data?.data);
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({ message: e?.parsedText, type: "error" })
    );
  } finally {
    store.dispatch(setIsLoading(false));
  }
}

async function postBrands(
  oauthTokenHeader: string,
  data: any,
  setSuccess: any
) {
  try {
    store.dispatch(setIsLoading(true));
    const response = await etlLogsService.postBrands(oauthTokenHeader, data);
    if (!response || !response?.status || response.status !== 200) {
      throw new Error("Failed to get page content");
    } else {
      setSuccess("success");
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({ message: e?.parsedText, type: "error" })
    );
  } finally {
    store.dispatch(setIsLoading(false));
  }
}

export const ETLLogsEndPointLogic = {
  getLogs,
  getLogsForExport,
  getLogsById,
  runProcess,
  getDBTables,
  postMigrate,
  getBrands,
  postBrands,
};
